import Services from "assets/menu-icons/Services";

const services = {
  id: 'services',
  type: 'group',
  children: [{
    id: 'services',
    title: 'Услуги', 
    type: 'item',
    url: '/services',
    icon: Services,
    breadcrumbs: false
  }]
}

export default services;